import {
  ANNOTATION_EDIT_URL,
  ANNOTATION_LOCATION,
  ANNOTATION_ORIGIN_LOCATION,
  ANNOTATION_SOURCE_LOCATION,
  ANNOTATION_VIEW_URL,
  type Entity,
} from '@backstage/catalog-model';

function toHttpUrl(value?: string): string | undefined {
  if (!value?.trim()) {
    return undefined;
  }
  const raw = value.trim().replace(/^url:/i, '');
  if (!/^https?:\/\//i.test(raw)) {
    return undefined;
  }
  return raw;
}

export function readCatalogInfoUrl(entity: Entity): string | undefined {
  const annotations = entity.metadata.annotations ?? {};
  return (
    toHttpUrl(annotations[ANNOTATION_VIEW_URL]) ??
    toHttpUrl(annotations[ANNOTATION_EDIT_URL]) ??
    toHttpUrl(annotations[ANNOTATION_SOURCE_LOCATION]) ??
    toHttpUrl(annotations[ANNOTATION_LOCATION]) ??
    toHttpUrl(annotations[ANNOTATION_ORIGIN_LOCATION])
  );
}
